import { BaseWithFollowUsLayout } from "../layouts";
import { Container, InlineLink, NextPageWithLayout } from "@akte-mord/common";
import { Paper, Typography } from "@mui/material";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import i18nConfig from "../../next-i18next.config";
import React from "react";
import type { GetStaticProps } from "next";

const Retailers: NextPageWithLayout = () => (
  <Container>
    <Typography variant="h1">Händleranfragen und Buchhandlungen</Typography>
    <Typography variant="body1" paragraph>
      Wir freuen uns über neue Geschäftspartner, die unsere Fälle in ihr Sortiment aufnehmen möchten.
      Unsere Cold Cases für Erwachsene sind das perfekte Ergänzungsprodukt für eine krimiaffine
      Kundschaft.
    </Typography>

    <Typography variant="body1" paragraph>
      Wir arbeiten seit mehreren Jahren erfolgreich mit zahlreichen kleinen und großen Buchhandlungen,
      Fachgeschäften und Handelsketten zusammen. Dabei ist es unsere Überzeugung, dass eCommerce und
      stationärer Einzelhandel keine Gegensätze sein müssen – im Gegenteil: Wir erhalten immer häufiger
      Anfragen von Kunden, die speziell nach der Verfügbarkeit im lokalen Einzelhandel nachfragen.
    </Typography>

    <Typography variant="body1" paragraph>
      Über unseren direkten, digitalbasierten Vertrieb können wir Ihnen günstige Konditionen sowie eine
      zügige Abwicklung anbieten. Bitte kontaktieren Sie uns unter{" "}
      <InlineLink href="mailto:mail@akte-mord.de">mail@akte-mord.de</InlineLink>, um weitere
      Informationen zu erhalten.
    </Typography>

    <Paper sx={{ p: { xs: 2, sm: 4 }, mx: { xs: -2, sm: 0 }, my: { xs: 2, md: 4 } }}>
      <Typography variant="body1" paragraph>
        Suchen Sie nach Krimidinner-Titeln? Dann besuchen Sie unsere Seite{" "}
        <InlineLink href="https://www.culinario-mortale.de" target="_blank" rel="noopener noreferrer">
          https://www.culinario-mortale.de
        </InlineLink>
        . Natürlich können Sie alle unsere Titel, reihenübergreifend, zusammen bestellen. Gerne
        unterstützen wir Sie auch mit Werbematerialien, Thekendisplays und Informationsflyern.
      </Typography>
    </Paper>

    <Typography variant="body1" paragraph>
      Falls Sie nach einem ausgefallen Werbeträger suchen, freuen wir uns über Ihre Kontaktaufnahme.
      Unsere Fälle zeichnen sich durch starke Geschichten und ein durchdachtes Prinzip aus. Sie sind eine
      ideale Geschenkidee für Ihre Kunden und ihre Mitarbeiter, um die Bindung an Ihr Unternehmen und
      Ihre Marke zu stärken. Wir bieten Ihnen Private Label Varianten unserer Titel an. Damit erhalten
      Sie einen sehr ungewöhnlichen und individuellen Werbeträger, der garantiert auffällt und Ihren
      Kunden lange im Gedächtnis bleibt.
    </Typography>
  </Container>
);

Retailers.getLayout = (page) => (
  <BaseWithFollowUsLayout
    title="Händleranfragen | Akte Mord® Cold Cases für Zuhause"
    description="Wir freuen uns über neue Geschäftspartner, die unsere Fälle in ihr Sortiment aufnehmen
          möchten."
  >
    {page}
  </BaseWithFollowUsLayout>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale ? await serverSideTranslations(locale, ["c-common"], i18nConfig) : {}),
    },
  };
};

export default Retailers;
